import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const MessageContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#E8F8F3',
  borderLeft: '4px solid var(--success-main, #13CA82)',
  borderRadius: '4px',
  padding: '12px 16px',
  marginTop: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
}));

const IconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'var(--success-main, #13CA82)',
  minWidth: '24px',
});

const MessageText = styled(Typography)({
  color: 'var(--primary-blue, #0B4598)',
  fontSize: '15px',
  fontWeight: 600,
  lineHeight: '20px',
  flex: 1,
});

const SecondaryText = styled(Typography)({
  color: 'var(--text-secondary, rgba(0, 0, 0, 0.6))',
  fontSize: '13px',
  lineHeight: '18px',
  marginTop: '4px',
});

interface PromotionalMessageProps {
  daysRemaining: number;
  promotionEndDate?: string | null;
}

const PromotionalMessage: React.FC<PromotionalMessageProps> = ({
  daysRemaining,
  promotionEndDate,
}) => {
  if (daysRemaining <= 0) {
    return null;
  }

  const dayText = daysRemaining === 1 ? 'day' : 'days';
  
  const formatEndDate = (dateString: string | null) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      });
    } catch {
      return '';
    }
  };

  return (
    <MessageContainer role="status" aria-live="polite">
      <IconWrapper>
        <CheckCircleOutlineIcon fontSize="small" />
      </IconWrapper>
      <Box>
        <MessageText>
          Don't worry, you don't pay placement fees for {daysRemaining} more {dayText}!
        </MessageText>
        {promotionEndDate && (
          <SecondaryText>
            Your promotion ends on {formatEndDate(promotionEndDate)}
          </SecondaryText>
        )}
      </Box>
    </MessageContainer>
  );
};

export default PromotionalMessage;

